"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FACET_FILTER_LOADING = exports.FACET_FILTER_BUTTON = void 0;
const FACET_FILTER_BUTTON = exports.FACET_FILTER_BUTTON = 'facet-filter-button';
const FACET_FILTER_LOADING = exports.FACET_FILTER_LOADING = 'facet-filter-loading';
